import { jsx, jsxs } from "react/jsx-runtime";
import { useClassNameFactory } from "@contember/react-utils";
import { memo, forwardRef } from "react";
const EditorBlock = memo(forwardRef(({
  children,
  dragHandle,
  dragLine,
  isDragged
}, ref) => {
  const componentClassName = useClassNameFactory("editorBlock");
  return /* @__PURE__ */ jsx("div", { className: componentClassName("", isDragged && "is-dragged"), ref, children: /* @__PURE__ */ jsxs("div", { className: componentClassName("inner"), children: [
    dragHandle && /* @__PURE__ */ jsx("div", { className: componentClassName("dragHandle"), contentEditable: false, children: dragHandle }),
    /* @__PURE__ */ jsx("div", { className: componentClassName("content"), children })
  ] }) });
}));
export {
  EditorBlock
};
//# sourceMappingURL=EditorBlock.js.map
